import IconDefault from '@assets/images/icons/mimeTypes/default.svg'
import IconDoc from '@assets/images/icons/mimeTypes/doc.svg'
import IconDocx from '@assets/images/icons/mimeTypes/docx.svg'
import IconJpeg from '@assets/images/icons/mimeTypes/jpeg.svg'
import IconJpg from '@assets/images/icons/mimeTypes/jpg.svg'
import IconJson from '@assets/images/icons/mimeTypes/json.svg'
import IconMp3 from '@assets/images/icons/mimeTypes/mp3.svg'
import IconPdf from '@assets/images/icons/mimeTypes/pdf.svg'
import IconPpt from '@assets/images/icons/mimeTypes/ppt.svg'
import IconPptx from '@assets/images/icons/mimeTypes/pptx.svg'
import IconPng from '@assets/images/icons/mimeTypes/png.svg'
import IconXls from '@assets/images/icons/mimeTypes/xls.svg'
import IconXlsx from '@assets/images/icons/mimeTypes/xlsx.svg'
import IconXml from '@assets/images/icons/mimeTypes/xml.svg'
import IconZip from '@assets/images/icons/mimeTypes/zip.svg'

import { splitFilename } from '@/modules/_helpers/splitFilename'

const getFileIcon = (mimetype, name) => {
  switch (mimetype) {
    case 'image/png':
      return IconPng
    case 'image/jpg':
      return IconJpeg
    case 'image/jpeg':
      return IconJpg
    case 'application/pdf':
      return IconPdf
    default:
      if (!name) {
        return IconDefault
      }
      switch (splitFilename(name).suffix?.toLowerCase()) {
        case '.xls':
        case '.csv':
          return IconXls
        case '.xlsx':
          return IconXlsx
        case '.doc':
          return IconDoc
        case '.docx':
          return IconDocx
        case '.ppt':
          return IconPpt
        case '.pptx':
          return IconPptx
        case '.json':
          return IconJson
        case '.mp3':
          return IconMp3
        case '.xml':
          return IconXml
        case '.zip':
          return IconZip
        default:
          return IconDefault
      }
  }
}

export default getFileIcon
